import { useContext, useEffect, useState, MouseEvent } from 'react';
import {
    Container,
    Dialog,
    DialogTitle,
    Divider,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

import { UserStats } from '../../../models/User';
import UserAPI from '../../../api/UserAPI';
import { SessionContext, SessionContextType } from '../../../contexts/session';
import StyledButton from '../../../components/basics/StyledButton/StyledButton';
import { RoutePaths } from '../../../components/core/AppRouter/AppRouter';
import ShareSite from '../../../components/site/ShareSite/ShareSite';
import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../contexts/anonUser';
import {
    UserActivityContext,
    UserActivityContextType,
} from '../../../contexts/userActivity';

interface UserStatsModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserStatsModal = (props: UserStatsModalProps): JSX.Element | null => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const [userStats, setUserStats] = useState<UserStats>();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const { userActivity } =
        useContext<UserActivityContextType>(UserActivityContext);

    useEffect(() => {
        const fetchStats = async () => {
            const statsFetched = await UserAPI.getSelfStats(session);

            if (statsFetched.userId) {
                setUserStats(statsFetched);
            }
        };

        if (props.open) {
            if (session.user !== undefined) {
                fetchStats();
            }

            if (anonUser.user !== undefined) {
                const stat = {
                    current: userActivity.votes,
                    count: 0,
                    resetAt: 0,
                };

                setUserStats({
                    userId: anonUser.user.id,
                    voteStats: {
                        daily: stat,
                        weekly: stat,
                        monthly: stat,
                        yearly: stat,
                        total: userActivity.votes,
                    },
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open]);

    const onCloseHandler = () => {
        props.setOpen(false);
    };

    const onCreatePollClickHandler = () => {
        navigate(`/${RoutePaths.NewPoll}`);
    };

    const onShareSiteClickHandler = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };

    return userStats !== undefined ? (
        <>
            <Dialog onClose={onCloseHandler} open={props.open}>
                <DialogTitle>
                    <Typography fontSize={'1.4rem'}>
                        {Boolean(userStats?.voteStats?.daily) && (
                            <>
                                You voted{' '}
                                {Number(userStats?.voteStats?.daily.current)}{' '}
                                time
                                {Number(userStats?.voteStats?.daily.current) > 1
                                    ? 's!'
                                    : '!'}
                            </>
                        )}
                    </Typography>
                    <IconButton
                        aria-label='close'
                        onClick={onCloseHandler}
                        sx={{
                            position: 'absolute',
                            right: '0.8rem',
                            top: '0.8rem',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                {/* <DialogContent
                    sx={{
                        minWidth: '20rem',
                    }}
                >
                    <Stack spacing={3}>
                        <Typography fontSize={'1.2rem'}>
                            {Boolean(userStats?.pollStats?.daily) && (
                                <>
                                    You created{' '}
                                    {Number(
                                        userStats?.pollStats?.daily.current,
                                    )}{' '}
                                    question
                                    {Number(
                                        userStats?.pollStats?.daily.current,
                                    ) > 1
                                        ? 's!'
                                        : '!'}
                                </>
                            )}
                        </Typography>
                        <Typography fontSize={'1.2rem'}>
                            {Boolean(userStats?.voteStats?.daily) && (
                                <>
                                    You voted{' '}
                                    {Number(
                                        userStats?.voteStats?.daily.current,
                                    )}{' '}
                                    time
                                    {Number(
                                        userStats?.voteStats?.daily.current,
                                    ) > 1
                                        ? 's!'
                                        : '!'}
                                </>
                            )}
                        </Typography>
                        <Typography fontSize={'1.2rem'}>
                            {Boolean(userStats?.commentStats?.daily) && (
                                <>
                                    You added{' '}
                                    {Number(
                                        userStats?.commentStats?.daily.current,
                                    )}{' '}
                                    comment
                                    {Number(
                                        userStats?.commentStats?.daily.current,
                                    ) > 1
                                        ? 's!'
                                        : '!'}
                                </>
                            )}
                        </Typography>
                    </Stack>
                </DialogContent>
                <Divider /> */}
                <Container sx={{ mt: 3, mb: 3 }}>
                    <Stack spacing={3} alignItems='center'>
                        <StyledButton
                            variant='contained'
                            onClick={onShareSiteClickHandler}
                        >
                            Share SeleOne with friends
                        </StyledButton>
                        <StyledButton
                            variant='contained'
                            onClick={onCreatePollClickHandler}
                        >
                            Add your own question
                        </StyledButton>
                        <StyledButton
                            variant='contained'
                            onClick={onCloseHandler}
                        >
                            See more questions
                        </StyledButton>
                    </Stack>
                </Container>
            </Dialog>
            <ShareSite anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
        </>
    ) : null;
};

export default UserStatsModal;
